import {styled} from "@styled-system/jsx";
import {paragraph} from "@styled-system/recipes";

const Paragraph = styled("p", paragraph);

export default Paragraph;
